export default "/images/vendor/flag-icon-css/flags/1x1/cg.svg?862f4608de0f8e9d213cd201d252cecc";